import { English as AUTH } from "../../../Web/Views/Public/_Auth/_Resources/_Translate/English";

export const ENGLISH = {

    AUTH,

    COMPANY: {
        CLAIM: "Private workspace for projects, documents, finances and credentials",
        RIGHTS: "All rights reserved.",
    },

    TEMPLATES: {

        banner: {
            devMode: "⚠️ DEVELOPMENT MODE: Some features may not be available.",
            devModeHide: "Hide the notice until the next refresh",
            devModeHideAria: "Hide the development mode notice",
        },

        alerts: {
            confirmTitle: "Confirm this action?",
            confirmOk: "Confirm",
            cancel: "Cancel",
            archiveTitle: "Archive this record?",
            archiveOk: "Yes, archive it",
            deleteTitle: "Delete permanently?",
            deleteOk: "Delete permanently",
            deleteInputLabel: "To confirm, type exactly: ",
            deleteInputPlaceholder: "Type here to enable the button",
            bulkDeleteTitle: "Confirm the bulk deletion",
            bulkDeletePlaceholder: "Type DELETE",
            bulkDeleteHint: "To confirm, type:",
            bulkDeleteWord: "DELETE",
            errCode: "The code must be 6 digits.",
            errWord: "You must type DELETE exactly.",
            importTitle: "Could not import",
            importMore: "…and {{count}} more row(s) with errors.",
            successTitle: "Done!",
            errorTitle: "Something went wrong",
            warningTitle: "Heads up",
            infoTitle: "Information",
            loadingTitle: "Processing...",
            ok: "OK",
            close: "Close",
            understood: "Got it",
        },

        nav: {
            main: "Main",
            openAside: "Open side menu",
            openMenu: "Open menu",
            closeMenu: "Close menu",
            defaultGroup: "Navigation",
            menu: "Navigation",
            sidebarGroup: "Dashboard",
        },

        header: {
            favs: "Favourites",
            favsEmpty: "You haven't saved anything yet",
            favsHint: "Tap the heart to save whatever interests you.",
            carts: "Cart",
            cartsEmpty: "Your cart is empty",
            cartsHint: "The products you add show up here.",
            checkout: "Checkout",
            notifications: "Notifications",
            notificationsEmpty: "You have no notifications",
            notificationsHint: "System alerts will show up here.",
            messages: "Messages",
            messagesEmpty: "You have no messages",
            messagesHint: "Team conversations show up here.",
            email: "Mail",
            emailEmpty: "You have no mail",
            emailHint: "Unread mail shows up here.",
            whatsapp: "WhatsApp",
            whatsappEmpty: "You have no conversations",
            whatsappHint: "Client messages show up here.",
            account: "My account",
            accountFallback: "Account",
            guest: "Guest",
            logout: "Sign out",
            myPanel: "My dashboard",
            myProfile: "My profile",
            archived: "Archived",
            appearance: "Appearance",
            language: "Language",
            themeLight: "Light",
            themeDark: "Dark",
            themeSystem: "System",
            portal: "Client portal",
            viewAll: "View all ({{total}}) · {{hidden}} more",
        },

        time: {
            now: "just now",
            minutes: "{{value}} min ago",
            hours: "{{value}} h ago",
            days: "{{value}} d ago",
        },
        common: {
            save: "Save",
            saveChanges: "Save changes",
            cancel: "Cancel",
            discard: "Discard",
            close: "Close",
            back: "Back",
            next: "Next",
            finish: "Finish",
            edit: "Edit",
            delete: "Delete",
            remove: "Remove",
            add: "Add",
            create: "Create",
            search: "Search…",
            filter: "Filter",
            clearAll: "Clear all",
            all: "All",
            retry: "Retry",
            reload: "Reload the page",
            loading: "Loading…",
            confirm: "Confirm",
            accept: "Accept",
            viewAll: "View all",
            seeMore: "See more",
            seeLess: "See less",
            copy: "Copy",
            copied: "Copied",
            print: "Print",
            export: "Export",
            import: "Import",
            today: "Today",
            yesterday: "Yesterday",
            empty: "No data",
            required: "This field is required",
            optional: "optional",
        },

        screen: {
            notFoundTitle: "We could not find this page",
            notFoundText: "The link may have changed or the page no longer exists.",
            goHome: "Go to home",
            reload: "Reload the page",
            requiredPermission: "Required permission",
            forbiddenTitle: "You do not have access to this",
            forbiddenText: "Your account cannot access this section. If you think this is a mistake, ask an administrator for access.",
            errorTitle: "Something went wrong",
            errorText: "We could not complete the operation. Please try again in a few seconds.",
            maintenanceTitle: "We are making improvements",
            maintenanceText: "The system will be back in a few minutes. Thanks for your patience.",
            maintenanceEta: "Estimated return",
            emptyTitle: "No data yet",
            emptyText: "The first record will show up here.",
            noticeTitle: "We could not load the information",
            noticeText: "The server responded without data. Try reloading or check the applied filters.",
            offlineTitle: "No connection to the server",
            offlineText: "We got no response. Check your connection and try again.",
        },

        form: {
            unsavedChanges: "You have unsaved changes",
            savedAt: "Saved",
            saveError: "We could not save your changes.",
            stepOf: "Step {{current}} of {{total}}",
            checkStep: "Please check the fields in this step.",
            validateError: "We could not validate this step.",
            noValue: "No value",
            cannotBeEmpty: "This field cannot be empty.",
            invalidValue: "Invalid value.",
            saveShortcut: "Ctrl + S",
        },

        table: {
            noResults: "No results",
            rowsCount: "{{count}} rows",
            perPage: "Per page",
            page: "Page",
            of: "of",
            selected: "{{count}} selected",
        },

        uploader: {
            dropTitle: "Drag files here or click",
            emptyList: "Nothing uploaded yet",
            uploadedCount: "{{done}} of {{total}} uploaded",
            clear: "Clear",
            tooLarge: "Exceeds the {{max}} limit.",
            wrongType: "File type not allowed.",
            maxFiles: "Maximum {{max}} files.",
        },

        social: {
            commentPlaceholder: "Write a comment…",
            commentSubmit: "Comment",
            reply: "Reply",
            noComments: "No comments yet",
            sendHint: "Ctrl + Enter to send",
            chatPlaceholder: "Write a message…",
            noMessages: "No messages yet",
            newMessages: "New messages",
            attach: "Attach a file",
            send: "Send",
        },

        notifications: {
            title: "Notifications",
            empty: "You have no notifications",
            emptyUnread: "You are all caught up",
            unread: "Unread",
            markAll: "Mark all as read",
            dismiss: "Dismiss notice",
            impersonation: "You are viewing the system as {{name}}. Everything you do is recorded under their name.",
            exitImpersonation: "Back to my account",
        },

        command: {
            placeholder: "Search for an action or a page…",
            empty: "No results",
            footer: "↑↓ to move · Enter to run · Esc to close",
            shortcutsTitle: "Keyboard shortcuts",
            shortcutsSearch: "Search a shortcut…",
            shortcutsEmpty: "No matching shortcuts",
        },

        calendar: {
            weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            months: [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December",
            ],
            month: "Month",
            agenda: "Agenda",
            today: "Today",
            noEvents: "No events this month",
            more: "+{{count}} more",
        },

        charts: {
            empty: "No data to plot",
            others: "Others",
            vsPrevious: "vs. previous period",
            noChanges: "No differences",
            before: "Before",
            after: "After",
            less: "Less",
            more: "More",
            totalCount: "{{count}} total",
        },

        pricing: {
            monthly: "Monthly",
            yearly: "Yearly",
            perMonth: "/mo",
            perYear: "/yr",
            savings: "Save {{percent}}%",
            choose: "Choose plan",
            custom: "Custom",
            comparison: "Full comparison",
            feature: "Feature",
        },

        config: {
            aesthetic: "Aesthetic",
            layout: "Layout",
            table: "Table",
            typography: "Typography",
            headerPublic: "Public header",
            headerPrivate: "Private header",
            theme: "Theme",
            alert: "Alerts",
            alertPosition: "Alert position",
            confirm: "Confirmations",
            editor: "Editor",

            appearance: "Appearance",
            implementation: "Implementation",
            locked: "Set by the project",
            costly: "Changing this option downloads a library",
            irreversible: "Saved content is not converted",
        },

        tour: {
            next: "Next",
            back: "Back",
            finish: "Done",
            skip: "Skip",
            stepOf: "Step {{current}} of {{total}}",
        },
    },

};
